/* eslint-disable max-len */
import React from 'react';
import {Input} from 'semantic-ui-react';

export const tableColumnsWithProps = (updateMyData) => {
  return [
    {
      'Header': () => <span className="header-title">CÉDULA</span>,
      'accessor': 'dealer',
      'className': 'cell-custom-inventory-models width-order-medium',
    },
    {
      'Header': () => <span className="header-title">DEALER</span>,
      'accessor': 'name',
      'className': 'cell-custom-inventory-models width-order-big',
    },
    {
      'Header': () => <span className="header-title">CUPO MÁXIMO</span>,
      'accessor': 'quota',
      'Cell': ({
        'value': initialValue,
        'row': {index},
        'column': {id},
      }) => {
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return (
          <Input
            min='0'
            type='number'
            value={initialValue}
            onChange={(e) => {
              handleChange(e.target.value || null);
            }}
            size='mini' />);
      },
      'className': 'cell-custom-inventory-models width-order-medium',
    },
  ];
};
